import React from 'react';
import {Button, Grid, Typography} from "@mui/material";
import IModal from "../../../components/Admin/Modal/IModal";
import IModalBody from "../../../components/Admin/Modal/IModalBody";
import classes from "./LogOut.module.scss"
import {GetState, SetState} from "../../../redux/reduxhelper";
import {useDispatch} from "react-redux";
import {IS_AUTH} from "../../../redux/action/type.action";
import {useNavigate} from "react-router";
import {successMessage} from "../../../tools/messages";

const LogOut = () => {
    const dispatch = useDispatch()
    const open = GetState("LOGOUT_MODAL", false);
    const navigate = useNavigate();
    const handleLogOut = () => {
        handleClose()
        dispatch(SetState(IS_AUTH, false));
        successMessage('با موفقیت خارج شدید')
        navigate('/admin/login');
    }


    const handleClose = () => {
        dispatch(SetState("LOGOUT_MODAL", false))
    }
    return (
        <IModal width={200} showClose={true} open={open} handleClose={handleClose}>
            <IModalBody className={classes.boxContainer}>
                <Grid>
                    <Typography>
                        آیا میخواهید خارج شوید
                    </Typography>
                    <Grid sx={{mx: 2, mt: 5}} display={"flex"} justifyContent={"space-between"}>
                        <Button onClick={handleLogOut} variant={'contained'} color={'success'}>بله</Button>
                        <Button onClick={handleClose} variant={'contained'} color={'error'}>خیر</Button>
                    </Grid>
                </Grid>

            </IModalBody>
        </IModal>
    );
};

export default LogOut;